import userBookingService from '@/api/userbooking'
import { USER_BOOKING } from '../types'
import strings from '@/strings'
import Vue from 'vue'

const proto = Vue.prototype

export default {
  namespaced: true,
  state: {
    bookings: [],
    startDate: '',
    finishDate: '',
    bookingTypes: []
  },
  getters: {
    bookings: (state) => {
      return state.bookings
    },
    startDate: (state) => {
      return state.startDate
    },
    finishDate: (state) => {
      return state.finishDate
    },
    bookingTypes: (state) => {
      return state.bookingTypes
    }
  },
  mutations: {
    [USER_BOOKING.SET_BOOKINGS](state, bookings) {
      state.bookings = bookings
    },
    [USER_BOOKING.CHANGE_STATUS](state, obj) {
      let index = state.bookings.findIndex(booking => booking.booking.id === obj.id)
      state.bookings[index].booking.status = obj.status
    },
    [USER_BOOKING.CHANGE_ROOM_STATUS](state, obj) {
      let index = state.bookings.findIndex(booking => booking.booking.id === obj.id)
      let roomIndex = state.bookings[index].rooms.findIndex(room => room.id === obj.roomId)
      state.bookings[index].rooms[roomIndex].status = obj.status
      state.bookings[index].rooms[roomIndex].rejected = obj.rejected
      state.bookings[index].rooms[roomIndex].isApproved = obj.isApproved
    },
    [USER_BOOKING.SET_START_TIME](state, val) {
      state.startDate = val
    },
    [USER_BOOKING.SET_FINISH_TIME](state, val) {
      state.finishDate = val
    },
    [USER_BOOKING.SET_BOOKING_TYPES](state, val) {
      state.bookingTypes = val
    },
    [USER_BOOKING.REMOVE_BOOKING](state, id) {
      let filteredBookings = state.bookings.filter(booking => booking.booking.id !== id)
      state.bookings = filteredBookings
    },
  },
  actions: {
    setBookings({ commit }, bookings) {
      commit(USER_BOOKING.SET_BOOKINGS, bookings)
    },
    setStartDate: function ({ commit }, val) {
      commit(USER_BOOKING.SET_START_TIME, val)
    },
    setFinishDate: function ({ commit }, val) {
      commit(USER_BOOKING.SET_FINISH_TIME, val)
    },
    setBookingTypes: function ({ commit }, val) {
      commit(USER_BOOKING.SET_BOOKING_TYPES, val)
    },
    changeBookingStateToCheckedIn({ commit }, bookingId) {
      commit(USER_BOOKING.CHANGE_STATUS,
        {
          id: bookingId,
          status: 'checkedIn'
        }
      )
    },
    removeBookingById({ commit }, bookingId) {
      commit(USER_BOOKING.REMOVE_BOOKING, bookingId)
    },
    changeBookingStateToCancelled({ commit }, bookingId) {
      commit(USER_BOOKING.CHANGE_STATUS,
        {
          id: bookingId,
          status: 'cancelled'
        }
      )
    },
    changeBookingStateToCheckedOut({ commit }, bookingId) {
      commit(USER_BOOKING.CHANGE_STATUS,
        {
          id: bookingId,
          status: 'checkedOut'
        }
      )
    },
    changeRoomBookingStateToCheckedOut({ commit }, booking) {
      commit(USER_BOOKING.CHANGE_ROOM_STATUS,
        {
          id: booking.id,
          roomId: booking.roomId,
          status: strings.roomStatusKey.rejected,
          rejected: true,
          isApproved: false
        }
      )
    },
    getBookingsOfCurrentUser({ dispatch, state }) {
      return new Promise((resolve, reject) => {
        let startDate = proto.$moment(state.startDate).utc().format()
        let finishDate = proto.$moment(state.finishDate).add(1, 'day').utc().format()
        userBookingService.getBookingsOfCurrentUser(startDate, finishDate).then((response) => {
          dispatch('setBookings', response.data)
          dispatch('Global/hideLoading', null, { root: true })
          resolve(response)
        }).catch((error) => {
          dispatch('Global/hideLoading', null, { root: true })
          reject(error)
        })
      })
    },
    getGuestsBookings({ dispatch, state }) {
      return new Promise((resolve, reject) => {
        let startDate = proto.$moment(state.startDate).utc().format()
        let finishDate = proto.$moment(state.finishDate).add(1, 'day').utc().format()
        userBookingService.getGuestsBookings(startDate, finishDate).then((response) => {
          dispatch('setBookings', response.data)
          dispatch('Global/hideLoading', null, { root: true })
          resolve(response)
        }).catch((error) => {
          dispatch('Global/hideLoading', null, { root: true })
          reject(error)
        })
      })
    }
  }
}
